module.exports = __webpack_public_path__ + "img/4.cacb9459.png";